export function Chargement () {

  return (
    <div className="cadre">
    	<br/>Chargement... <br/><br/>
    	
      <div className="loader logo_automaths">
      <svg height="40" viewBox="0 0 107 139" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
          <path d="M3 4H24.4008L53 37.5L79.2646 4H97V130L79.2646 107V46.3041L53 73L29.5 42.5L19 28C16 24 6.5 11 6.5 11L3 4Z" fill="#314159"></path>
          <path d="M3 4H24.4008L53 37.5L79.2646 4H97V130L79.2646 107V46.3041L53 73L29.5 42.5L19 28C16 24 6.5 11 6.5 11L3 4Z" stroke="#314159"></path>
        </g>
        <g filter="url(#filter1_d)">
          <path d="M97 130.5L3 5.5V127.5L21 107V76.5H35.75L67.5 123L97 130.5Z" fill="#BADA45"></path>
          <path d="M97 130.5L3 5.5V127.5L21 107V76.5H35.75L67.5 123L97 130.5Z"></path>
        </g>
        <g filter="url(#filter2_d)">
          <path d="M19 60.5H26.5L19 49V60.5Z" fill="white"></path>
          <path d="M19 60.5H26.5L19 49V60.5Z"></path>
        </g>
        <defs>
          <filter id="filter0_d" x="0.190979" y="0.5" width="105.309" height="137.967" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
            <feOffset dx="3" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter id="filter1_d" x="0.5" y="1.0032" width="105.753" height="137.331" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
            <feOffset dx="3" dy="2"></feOffset>
            <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
          <filter id="filter2_d" x="18.5" y="47.318" width="8.92302" height="13.682" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
            <feOffset></feOffset>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
          </filter>
        </defs>
      </svg>
    </div>
    <br/>
    Veuillez patienter...
    <br/><br/>
    </div>
  );
}